import { render, staticRenderFns } from "./primeoEnergie.vue?vue&type=template&id=53460a3a&"
import script from "./primeoEnergie.vue?vue&type=script&lang=js&"
export * from "./primeoEnergie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports